module.exports = __webpack_public_path__ + "img/skip-with-icon.ee4832f3.svg";